module.exports = __webpack_public_path__ + "img/2016_uk.d5cef2dc.svg";